import {
  getAddressFinderRestrictCountries,
  getDefaultCountryIso3,
  getRestrictCountryIso3Codes,
  resolveCountryFormValue
} from "@/utils/idealPostcodesCountry";

export function getShippingAddressFieldNames({ prefix = "", style = "camel" } = {}) {
  if (style === "snake") {
    const fieldPrefix = prefix ? `${prefix}.` : "";
    return {
      line1: `${fieldPrefix}line_1`,
      line2: `${fieldPrefix}line_2`,
      city: `${fieldPrefix}city`,
      postcode: `${fieldPrefix}postcode`,
      country: `${fieldPrefix}country`
    };
  }

  if (style === "shippingCamel") {
    return {
      line1: "shippingLine1",
      line2: "shippingLine2",
      city: "shippingCity",
      postcode: "shippingPostcode",
      country: "shippingCountry"
    };
  }

  const fieldPrefix = prefix ? `${prefix}.` : "";
  return {
    line1: `${fieldPrefix}line1`,
    line2: `${fieldPrefix}line2`,
    city: `${fieldPrefix}city`,
    postcode: `${fieldPrefix}postcode`,
    country: `${fieldPrefix}country`
  };
}

export function extractAddressFieldValues(address) {
  return {
    line1: address?.line_1 || "",
    line2: address?.line_2 || "",
    city: address?.post_town || "",
    postcode: address?.postcode || ""
  };
}

export function applyAddressToForm({
  address,
  fieldNames,
  setValue,
  shippingCountries = [],
  countryValueType = "isoCode",
  updateCountry = true,
  fallbackIso2
}) {
  const setOptions = { shouldDirty: true, shouldValidate: true };
  const values = extractAddressFieldValues(address);

  setValue(fieldNames.line1, values.line1, setOptions);
  setValue(fieldNames.line2, values.line2, setOptions);
  setValue(fieldNames.city, values.city, setOptions);
  setValue(fieldNames.postcode, values.postcode, setOptions);

  if (updateCountry && fieldNames.country) {
    const countryValue = resolveCountryFormValue({
      shippingCountries,
      address,
      fallbackIso2,
      countryValueType
    });

    if (countryValue !== undefined) {
      setValue(fieldNames.country, countryValue, setOptions);
    }
  }
}

export { getAddressFinderRestrictCountries, getDefaultCountryIso3, getRestrictCountryIso3Codes, resolveCountryFormValue };
